export default __webpack_public_path__ + "static/media/crypto deposit.4416cc0e.png";